import _ from 'lodash';
import { fetchPrepaymentAmount } from '../../src/RazorTS/Invoicing/Prepayment';

'use strict';

const PaymentMethod = {
    Cash : '1'
}

function OrderSaveableChecker() {
    this.saveBlockingPromise = Promise.resolve();
    this.saveBlockingPromisesCounter = 0;
}

OrderSaveableChecker.prototype.canBeSaved = function () {
    return this.saveBlockingPromisesCounter === 0;
}

OrderSaveableChecker.prototype.queueSaveBlockingPromise = function (promise) {
    SharedOrderFunctions.saveButtonSetDataLoading(true);
    this.saveBlockingPromisesCounter++;

    this.saveBlockingPromise =
        this.saveBlockingPromise
            .then(() => {
                return promise;
            });
    this._unlockIfPossible();
}

OrderSaveableChecker.prototype.queueSaveBlockingAction = function(action) {
    SharedOrderFunctions.setSaveDisabled(true);
    this.saveBlockingPromise = this.saveBlockingPromise.then(action);
    this._unlockIfPossible();
}

OrderSaveableChecker.prototype.queueSave = function(saveFunc) {
    SharedOrderFunctions.setSaveDisabled(true);
    this.saveBlockingPromise = this.saveBlockingPromise.then(saveFunc);
}

OrderSaveableChecker.prototype._unlockIfPossible = function() {
    this.saveBlockingPromise = this.saveBlockingPromise
        .then(() => {
            if (this.saveBlockingPromisesCounter < 1) {
                console.warn("Were gonna have a problem, CHECK THIS CODE");
                this.saveBlockingPromisesCounter = 1;
            }

            this.saveBlockingPromisesCounter--;

            if (this.canBeSaved()) {
                SharedOrderFunctions.saveButtonSetDataLoading(false);
            }
        });
}

/*
 * Functions that are needed in both Add.js and Detail.js for the Order views should be added here
 *
 * NOTES: When writing a new function or moving a function here, assume that this function has NO ACCESS TO GLOBAL VARIABLES/FUNCTIONS!
 */
window.SharedOrderFunctions = {
    saveChecker: null,
    saveButtons: null,
    defaultTechnicianUID: null,
    defaultTechnicianText: null,
    isDefaultTechnicianFetched: false,
    SortPhysExportFormats: function() {
        throw new Error("Function needs to be overwritten in Add or Detail specific code");
    },
    checkOnDuty: function() {
        throw new Error("Function needs to be overwritten in Add or Detail specific code");
    },
    RefreshUrgencies: function() {
        throw new Error("Function needs to be overwritten in Add or Detail specific code");
    },
    GetInvoiceInformation: function(resetCustomTotals, radiologistChanged) {
        throw new Error("Function needs to be overwritten in Add or Detail specific code");
    },
    ValidatePaymentPlan: function() {
        const dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
        const amountPaymentPlan = dialog.find('#totalDonePaymentsPlan span').text();
        const totalAmount = SharedOrderFunctions.GetEffectiveInvoiceTotal();
        let stillToPay = 0;
        if ($.isNumeric(amountPaymentPlan)) {
            stillToPay = parseFloat(totalAmount, 10) - parseFloat(amountPaymentPlan, 10);
        } else {
            stillToPay = parseFloat(totalAmount, 10);
        }
        return stillToPay === 0 || amountPaymentPlan === 0;
    },
    ConfirmInvoiceFunctionality: function(e) {
        throw new Error("Function needs to be overwritten in Add or Detail specific code");
    },
    // Needs to be called for both add.js and detail.js
    reload_order_shared: function () {
        SharedOrderFunctions.saveChecker = new OrderSaveableChecker();
        SharedOrderFunctions.saveButtonSetDataLoading(false);
        SharedOrderFunctions.setSaveDisabled(false);
        SharedOrderFunctions.prepaymentOrderId = null;
        SharedOrderFunctions.prepaymentAmount = null;
        SharedOrderFunctions.prepaymentError = null;
    },
    saveButtonSetDataLoading: function(isLoading) {
        this.setSaveDisabled(isLoading);
        SharedOrderFunctions.saveButtons.toggleClass("loading", isLoading);
    },
    setSaveDisabled: function(isDisabled) {
        SharedOrderFunctions.saveButtons.prop("disabled", isDisabled);
    },
    InvoiceCashRoundUp: function(amountStillToPay, cashRound) {
        let canBeRounded = amountStillToPay % cashRound;
        canBeRounded = parseFloat(canBeRounded.toFixed(2));
        if (Math.abs(canBeRounded) > 0) {
            return Math.ceil(amountStillToPay / cashRound) * cashRound;
        }
        return amountStillToPay;
    },
    InvoiceCashRoundToNearest: function(amountStillToPay, cashRound) {
        return Math.round(amountStillToPay / cashRound) * cashRound;  
    },
    ApplyRoundingIfNeeded: function(amountStillToPay) {
        const isCashPaymentMethod = $("#PayedByMethod").val() === PaymentMethod.Cash;
        const cashRound = parseFloat($('#cashRound').val());
        const roundInvoiceUp = $("#roundInvoiceUp").val() == 'true';
        
        amountStillToPay = parseFloat(amountStillToPay.toFixed(2));
        
        if (isCashPaymentMethod && cashRound !== 0.01) {

            if (roundInvoiceUp) {
                amountStillToPay = this.InvoiceCashRoundUp(amountStillToPay, cashRound);
            }
            else {
                amountStillToPay = this.InvoiceCashRoundToNearest(amountStillToPay, cashRound)
            }
        }
        return amountStillToPay;
    },
    CreateProcedureEFHTML: function (i, x, resourcePartialReport) {
        let toAdd = '<td>' + x.ProcedureName;
        toAdd += '<input type="hidden" class="procedureEFProcedureName" name="ListProcedureExportFormat[' + i + '].ProcedureName" value="' + x.ProcedureName + '" />';
        toAdd += '<input type="hidden" class="procedureEFProcedureID" name="ListProcedureExportFormat[' + i + '].ProcedureID" value="' + x.ProcedureID + '" />';
        toAdd += '</td>';
        toAdd += '<td>' + x.Name;
        if (x.UseInPartial) {
            toAdd += ' (' + $("<div/>").html(resourcePartialReport).text() + ')';
        }
        toAdd += '<input type="hidden" class="procedureEFName" name="ListProcedureExportFormat[' + i + '].Name" value="' + x.Name + '" />';
        toAdd += '<input type="hidden" class="procedureEFID" name="ListProcedureExportFormat[' + i + '].ID" value="' + x.ID + '" />';
        toAdd += '<input type="hidden" class="procedureEFLinkID" name="ListProcedureExportFormat[' + i + '].LinkID" value="' + x.LinkID + '" />';
        toAdd += '<input type="hidden" class="procedureEFProcedureLinkID" name="ListProcedureExportFormat[' + i + '].ProcedureLinkID" value="' + x.ProcedureLinkID + '" />';
        toAdd += '<input type="hidden" class="procedureEFPartial" name="ListProcedureExportFormat[' + i + '].UseInPartial" value="' + x.UseInPartial + '" />';
        toAdd += '</td>';
        toAdd += '<td>' + x.TriggerStatus;
        toAdd += '<input type="hidden" class="triggerStatus" name="ListProcedureExportFormat[' + i + '].TriggerStatus" value="' + x.TriggerStatus + '" />';
        toAdd += '<input type="hidden" class="procedureEFOrderTriggerStatus" name="ListProcedureExportFormat[' + i + '].OrderTriggerStatus_UID" value="' + x.OrderTriggerStatus_UID + '" />';
        toAdd += '<input type="hidden" class="procedureEFReportTriggerStatus" name="ListProcedureExportFormat[' + i + '].ReportTriggerStatus_UID" value="' + x.ReportTriggerStatus_UID + '" />';
        toAdd += '</td>';
        return toAdd;
    },

    CheckMotivationLettersCall: function(patientID, implementation, orderID, procedureIDs) {
        return $.ajax({
            traditional: true,
            type: "POST",
            url: "/legacy/Orders/CheckMotivationLettersByProcedureUIDs",
            dataType: 'json',
            data: {
                Patient_UID: patientID,
                Implementation: implementation,
                Order_UID: orderID,
                Procedure_UIDs: procedureIDs
            },
        });
    },

    FindPatientsToMergeForOrder: function(viewbagUniquePrefix, modelPatientID) {
        const filter = $('input#searchMergePatient' + viewbagUniquePrefix).val();
        $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').find('tr.record').remove();
        $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').find('tr.noRecords').remove();
        $('button#btnConfirmMerge' + viewbagUniquePrefix).attr('disabled', true);
        $.ajax({
            type: 'GET',
            url: '/legacy/Patients/FilterPatientsForMerge',
            data: {
                Filter: filter,
                idToExclude: modelPatientID
            },
            async: false,
            dataType: 'json',
            success: function (data) {
                if (data.Items.length > 0) {
                    $.each(data.Items, function (i, data) {
                        let toAppend = '<tr class="record">';
                        toAppend += '<td class="id center">' + data.ID + '</td>';
                        toAppend += '<td class="fullName">' + data.FullName + '</td>';
                        toAppend += '<td class="address">' + data.Address + '</td>';
                        toAppend += '<td class="dob center">' + data.DOBdmy + '</td>';
                        toAppend += '<td class="nrn center">' + data.NationalNumber + '</td>';
                        toAppend += '</tr>';
                        $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').append(toAppend);
                    });
                } else {
                    $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').append('<tr class="noRecords"><td colspan="5">resourceNoPatientsFound</td></tr>');
                }
            }
        });
    },
    setAutocompleteApplicantLoading: function (isLoading, appType, data, response) {
        const longAppType = {App: 'Applicant', AppCC: 'Applicant_CC', AppCC2: 'Applicant_CC_2'}[appType];
        const inputFieldID = "#" + longAppType + "_Text";
        const input = $(inputFieldID);

        setAutocompleteInputLoading(isLoading, input);
        if(isLoading) return;

        let physicians = data.physicians;
        if (physicians.length === 0) {
            input.css('border-color', '#CD0A0A');
        }
        setPhysicianAutocompleteResults(data, response);
    },
    /*
        Applicant logic
    */
    resetAndSetLoadingApplicantForAutocomplete: function (appType, viewbagUniquePrefix) {
        SharedOrderFunctions.clearApplicantDataBesidesTextField(appType, viewbagUniquePrefix);
        SharedOrderFunctions.setAutocompleteApplicantLoading(true, appType);
    },
    clearApplicantDataBesidesTextField: function (appType, viewbagUniquePrefix) {
        const longAppType = {App: 'Applicant', AppCC: 'Applicant_CC', AppCC2: 'Applicant_CC_2'}[appType];

        const applicantUIDInputID = "input#" + longAppType + "_UID";
        const applicantTextInputID = "input#" + longAppType + "_Text";
        const applicantContactDropdownID = "select#" + longAppType + "_ContactID";

        modelApplicantId = null;
        $(applicantUIDInputID).val("0");
        const applicantTextInput = $(applicantTextInputID);
        applicantTextInput.attr('title', "");

        const dropdown = $(applicantContactDropdownID);
        dropdown.empty();
        dropdown.prop("disabled", true);

        SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(false, appType, viewbagUniquePrefix);
        SharedOrderFunctions.DeletePhysicianExportFormats(appType);
    },
    setActiveApplicantDetailAndRemoveMenuOptions: function (active, appType, viewbagUniquePrefix) {
        const removeMenuOptionID = "a#remove" + appType + viewbagUniquePrefix;
        const detailMenuOptionID = "a#show" + appType + "Detail" + viewbagUniquePrefix;

        const removeMenuOption = $(removeMenuOptionID);
        const detailMenuOption = $(detailMenuOptionID)
        if (active) {
            removeMenuOption.removeClass('inActive');
            detailMenuOption.removeClass('inActive');
        } else {
            removeMenuOption.addClass('inActive');
            detailMenuOption.addClass('inActive');
        }
    },
    LoadApplicantWithID: function (physicianID, app, viewbagUniquePrefix) {
        if(physicianID === -1) return;

        const AppType = {App: 'Applicant', AppCC: 'Applicant_CC', AppCC2: 'Applicant_CC_2'}[app]
        const applicantIDInputID = "input#" + AppType + "_UID";
        const applicantTextInputID = "input#" + AppType + "_Text";

        // TODO could later be further improved to return a json with the physician basic info + contact informations
        // to reduce to 1 call instead of 2
        // WATCH OUT EVERYWHERE YOU USED LoadPhyscianExportFormats
        const promise = fetch("/legacy/Physicians/GetPhysicianStringTextByID?" +
            new URLSearchParams({
                id: physicianID
            }),
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                const physcianName = data.Text;

                const applicantID = $(applicantIDInputID);
                const applicantText = $(applicantTextInputID);

                applicantID.attr('value', physicianID);
                applicantText.attr('value', physcianName);
                applicantText.attr('title', physcianName);
                applicantText.val(physcianName);
                applicantText.css('border-color', '#999');

                LoadRequestForm(app, physicianID, physcianName);

                SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(true, app, viewbagUniquePrefix);
            })
            .then(function () {
                return Promise.all([
                    new Promise(function (resolve) {
                        if (app === "App") {
                            modelApplicantId = physicianID;
                            SharedOrderFunctions.RefreshUrgencies().then(resolve());
                        }
                        resolve();
                    }),
                    SharedOrderFunctions.LoadContactInformationDropdown(physicianID, app)
                ]);
            })
            .catch(function (error) {
                console.log(error);
            });

        return promise;
    },
    LoadSelectedApplicantFromPopupOfType: function (app, viewbagUniquePrefix) {
        const AppType = {App: 'Applicant', AppCC: 'ApplicantCC', AppCC2: 'ApplicantCC2'}[app];
        const gridID = "#gridFind" + AppType;
        const findDialogID = "#divFind" + AppType + viewbagUniquePrefix;

        const id = $(gridID + viewbagUniquePrefix).find('tr.focus').find('td.rowId').html();

        const promise = new Promise(function (resolve) {
            SharedOrderFunctions.removeApplicant(app, viewbagUniquePrefix);
            resolve();
        })
        .then(function() {
            return SharedOrderFunctions.LoadApplicantWithID(id, app, viewbagUniquePrefix);
        })
        .then(function() {
            $(findDialogID).dialog("close");
        })
        .catch(function(error) {
            console.error(error);
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);
    },
    LoadSelectedApplicant: function (viewbagUniquePrefix) {
        SharedOrderFunctions.LoadSelectedApplicantFromPopupOfType("App", viewbagUniquePrefix);
    },
    LoadSelectedAppCC: function (viewbagUniquePrefix) {
        SharedOrderFunctions.LoadSelectedApplicantFromPopupOfType("AppCC", viewbagUniquePrefix);
    },
    LoadSelectedAppCC2: function (viewbagUniquePrefix) {
        SharedOrderFunctions.LoadSelectedApplicantFromPopupOfType("AppCC2", viewbagUniquePrefix);
    },
    LoadContactInformationDropdown: function (physicianId, applicantType) {
        const CC = applicantType === "AppCC";
        const CC2 = applicantType === "AppCC2";

        const promise = fetch("/legacy/Json/GetContactInformationDropdownForPhysician?" +
            new URLSearchParams({
                physicianId: physicianId
            }),
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        ).then(function (response) {
            return response.json();
        })
        .then(function (data) {
            let dropDownJquery;
            if (CC) {
                dropDownJquery = $('#Applicant_CC_ContactID');
            }
            else if (CC2) {
                dropDownJquery = $('#Applicant_CC_2_ContactID');
            } else {
                dropDownJquery = $('#Applicant_ContactID');
            }

            dropDownJquery.empty();
            const dropDown = dropDownJquery[0];
            _.forEach(data, function (optionData) {
                const option = new Option(optionData.Text, optionData.Value, optionData.Selected, optionData.Selected);
                dropDown.add(option);
            });
            dropDownJquery.removeAttr("disabled");
        })
        .then(function() {
            return SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType(applicantType);
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);

        return promise;
    },
    SwitchRequestingAndCCApplicant: function (viewbagUniquePrefix) {
        const switchBtn = $(".switchRequestingAndCC");
        if (switchBtn.attr("disabled"))
            return Promise.resolve();

        switchBtn.attr("disabled", true);

        const promise = new Promise(function (resolve) {

            const appid = $('input#Applicant_UID').val();
            const appcontactid = $('#Applicant_ContactID').val();
            const apptext = appid == 0 ? "" : $('input#Applicant_Text').val();

            const appccid = $('input#Applicant_CC_UID').val();
            const appcccontactid = $('#Applicant_CC_ContactID').val();
            const appcctext = appccid == 0 ? "" : $('input#Applicant_CC_Text').val();

            //do the actual switch
            $('input#Applicant_UID').val(appccid);
            $('input#Applicant_UID').attr('value', appccid);

            $('input#Applicant_CC_UID').val(appid);
            $('input#Applicant_CC_UID').attr('value', appid);

            $('input#Applicant_Text').val(appcctext);
            $('input#Applicant_Text').attr('value', appcctext);
            $('input#Applicant_Text').attr('title', appcctext);

            $('input#Applicant_CC_Text').val(apptext);
            $('input#Applicant_CC_Text').attr('value', apptext);
            $('input#Applicant_CC_Text').attr('title', apptext);

            const $optionsAppContact = $("#Applicant_ContactID > option").clone();
            const $optionsAppCCContact = $("#Applicant_CC_ContactID > option").clone();

            const $appContactDropdown = $("#Applicant_ContactID");
            $appContactDropdown.empty();
            $appContactDropdown.append($optionsAppCCContact);

            const $appCCContactDropdown = $("#Applicant_CC_ContactID");
            $appCCContactDropdown.empty();
            $appCCContactDropdown.append($optionsAppContact);

            $appContactDropdown.val(appcccontactid).change();
            $appCCContactDropdown.val(appcontactid).change();

            modelApplicantId = appccid;

            $('#Applicant_Text').css('border-color', '#999');
            $('#Applicant_CC_Text').css('border-color', '#999');

            if ($('input#Applicant_UID').attr('value') == 0) {
                $('a#showAppDetail' + viewbagUniquePrefix).addClass('inActive');
                $('a#removeApp' + viewbagUniquePrefix).addClass('inActive');
            }
            else {
                $('a#showAppDetail' + viewbagUniquePrefix).removeClass('inActive');
                $('a#removeApp' + viewbagUniquePrefix).removeClass('inActive');
            }
            if ($('input#Applicant_CC_UID').attr('value') == 0) {
                $('a#showAppCCDetail' + viewbagUniquePrefix).addClass('inActive');
                $('a#removeAppCC' + viewbagUniquePrefix).addClass('inActive');
            }
            else {
                $('a#showAppCCDetail' + viewbagUniquePrefix).removeClass('inActive');
                $('a#removeAppCC' + viewbagUniquePrefix).removeClass('inActive');
            }

            SharedOrderFunctions.DeletePhysicianExportFormats("App");
            SharedOrderFunctions.DeletePhysicianExportFormats("AppCC");

            return SharedOrderFunctions.RefreshUrgencies().then(resolve());
        })
        .then(function () {
            switchBtn.removeAttr("disabled");
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);

        return promise;
    },
    removeApplicant: function (appType, viewbagUniquePrefix) {
        const longAppType = {App: 'Applicant', AppCC: 'Applicant_CC', AppCC2: 'Applicant_CC_2'}[appType];

        const applicantTextInputID = "input#" + longAppType + "_Text";
        const applicantTextInput = $(applicantTextInputID);
        applicantTextInput.attr('value', "");
        applicantTextInput.val('');

        SharedOrderFunctions.clearApplicantDataBesidesTextField(appType, viewbagUniquePrefix);
    },
    /*
        Procedures
    */
    GenerateProcedureExportFormatRowNode: function (x, i) {
        let element = '<tr class="procedureExportFormatRow" id="' + x.LinkID + '">';
        element += '<td>' + x.ProcedureName;
        element += '<input type="hidden" class="procedureEFProcedureName" name="ListProcedureExportFormat[' + i + '].ProcedureName" value="' + x.ProcedureName + '" />';
        element += '<input type="hidden" class="procedureEFProcedureID" name="ListProcedureExportFormat[' + i + '].ProcedureID" value="' + x.ProcedureID + '" />';
        element += '</td>';
        element += '<td>' + x.Name;
        if (x.UseInPartial) {
            element += ' (' + $("<div/>").html(resourcePartialReport).text() + ')';
        }
        element += '<input type="hidden" class="procedureEFName" name="ListProcedureExportFormat[' + i + '].Name" value="' + x.Name + '" />';
        element += '<input type="hidden" class="procedureEFID" name="ListProcedureExportFormat[' + i + '].ID" value="' + x.ID + '" />';
        element += '<input type="hidden" class="procedureEFLinkID" name="ListProcedureExportFormat[' + i + '].LinkID" value="' + x.LinkID + '" />';
        element += '<input type="hidden" class="procedureEFProcedureLinkID" name="ListProcedureExportFormat[' + i + '].ProcedureLinkID" value="' + x.ProcedureLinkID + '" />';
        element += '<input type="hidden" class="procedureEFPartial" name="ListProcedureExportFormat[' + i + '].UseInPartial" value="' + x.UseInPartial + '" />';
        element += '</td>';
        element += '<td>' + x.TriggerStatus;
        element += '<input type="hidden" class="triggerStatus" name="ListProcedureExportFormat[' + i + '].TriggerStatus" value="' + x.TriggerStatus + '" />';
        element += '<input type="hidden" class="procedureEFOrderTriggerStatus" name="ListProcedureExportFormat[' + i + '].OrderTriggerStatus_UID" value="' + x.OrderTriggerStatus_UID + '" />';
        element += '<input type="hidden" class="procedureEFReportTriggerStatus" name="ListProcedureExportFormat[' + i + '].ReportTriggerStatus_UID" value="' + x.ReportTriggerStatus_UID + '" />';
        element += '</td>';
        element += '<td class="delete">resourceDelete</td>';
        element += '</tr>';

        return $.parseHTML(element);
    },
    GetAndSetProcedureExportFormatsForProcedureWithID: function (procedureID, orderProcedureID) {
        const existingEFsForProcedureWithID = $('table#tblProcedureExportFormat input.procedureEFProcedureID[value=' + procedureID + ']');
        if (existingEFsForProcedureWithID.length !== 0) {
            return SharedOrderFunctions.GetInvoiceInformation(false, false);
        }

        const promise = fetch("/legacy/Orders/GetExportFormatsByProcedure?" +
            new URLSearchParams({
                id: procedureID,
                Patient_UID: modelPatientID,
                Date: $('#DateOfImplementation').val(),
                UseProducts: useProducts,
                UseChecks: useChecks
            }),
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            const promises = [];
            if (data.Done) {
                $(data.Items).each(function (i, x) {
                    const element = SharedOrderFunctions.GenerateProcedureExportFormatRowNode(x, i);
                    $('table#tblProcedureExportFormat tbody').append(element);
                });
                if (useProducts) {
                    $(data.Products).each(function (i, x) {
                        promises.push(SharedOrderProductFunctions.AddProduct(x));
                    });
                    // TODO remove is done by AddProduct
                    promises.push(SharedOrderProductFunctions.SortSelectedProducts());
                    promises.push(SharedOrderProductFunctions.SortProductExportFormats());
                    SharedOrderFunctions.GetInvoiceInformation(true);
                }
                if (useChecks) {
                    orderProcedureID = (orderProcedureID === undefined) ? 0 : orderProcedureID;
                    $(data.Checks).each(function (i, x) {
                        x.FromOrderProcedure_UID = orderProcedureID;
                        if (orderProcedureID != 0) {
                            //edit
                            ChangeChecksByChangingProcedure(orderProcedureID, x);
                        } else {
                            //add
                            AddCheck(x);
                        }
                    });
                    if (orderProcedureID != 0) {
                        DeleteRemainingChecksAfterChangeProcedure(orderProcedureID, procedureID);
                    }
                    SortSelectedChecks();
                    if (useChecks) {
                        if ($('#GroupChecks').is(':checked')) {
                            groupChecks();
                        }
                    }
                }
            }
            return Promise.all(promises);
        })
        .then(function () {
            const promises = [];
            promises.push(SharedOrderFunctions.SortProceduresExportFormats());
            promises.push(SharedOrderFunctions.checkOnDuty());
            promises.push(SharedOrderFunctions.GetInvoiceInformation(true, false));
            return Promise.all(promises);
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);

        return promise;
    },
    /*
        Rooms
    */
    SetDefaultRoomFromOrderContext: function (row, viewbagDefaultRoomUID, viewbagDefaultRoomText) {
        if ($('input#CheckRoom').is(':checked')) {
            const firstProcedure = $('table#selectedProcedures tr.selectedProcedureItem').first();
            const roomUID = firstProcedure.find('input.roomUID').val();
            const roomText = firstProcedure.find('input.roomText').val();

            if (roomUID) {
                row.find('input.roomUID').val(roomUID);
                row.find('input.roomUID').attr('value', roomUID);
                row.find('input.roomText').val(roomText);
                row.find('input.roomText').attr('value', roomText);
                return Promise.resolve();
            }
        }

        const setDefaultRadiologistFromRoom = !$('input#CheckRadiologist').is(':checked');
        return SharedOrderFunctions.SetDefaultRoom(row, setDefaultRadiologistFromRoom, viewbagDefaultRoomUID, viewbagDefaultRoomText);
    },
    SetDefaultRoom: function (row, setDefaultRadiologist, viewbagDefaultRoomUID, viewbagDefaultRoomText) {
        const defaultRoomUid = viewbagDefaultRoomUID;
        const defaultRoomText = viewbagDefaultRoomText;
        let roomUid = defaultRoomUid;
        let roomText = defaultRoomText;
        let roomOnDuty = true;

        const promise = fetch("/legacy/Json/GetDefaultRoomForProcedureOnSite?" +
            new URLSearchParams({
                Proc_UID: row.attr('id'),
                Site_UID: $('#Site_UID').val()
            }),
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            if (data) {
                roomUid = data.ID;
                roomText = data.Name;
                roomOnDuty = data.UseOnDutyForAppointment;

                if (data.Radiologist.FullName != null && setDefaultRadiologist) {
                    const radUid = data.Radiologist.ID;
                    const radText = data.Radiologist.FullName;
                    row.find('.radUid').val(radUid);
                    row.find('.radUid').attr('value', radUid);
                    row.find('.radText').val(radText);
                    row.find('.radText').attr('value', radText);
                }
            }
            else {
                if ($('input#CheckRoom').is(':checked')) {
                    const firstOtherExistingProcedure = $('table#selectedProcedures tr.selectedProcedureItem').first();
                    const otherProcedureRoomUid = firstOtherExistingProcedure.find('input.roomUID').val();
                    const otherProcedureRoomText = firstOtherExistingProcedure.find('input.roomText').val();
                    const otherProcedureRoomOnDuty = firstOtherExistingProcedure.find('input.roomOnDuty').val();

                    if (otherProcedureRoomUid !== "") {
                        roomUid = otherProcedureRoomUid;
                        roomText = otherProcedureRoomText;
                        roomOnDuty = otherProcedureRoomOnDuty;
                    }
                }
            }
        })
        .finally(function () {
            row.find('.roomUID').val(roomUid);
            row.find('.roomUID').attr('value', roomUid);
            row.find('.roomText').val(roomText);
            row.find('.roomText').attr('value', roomText);
            row.find('.roomOnDuty').val(roomOnDuty);
            row.find('.roomOnDuty').attr('value', roomOnDuty);
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);
        return promise;
    },
    SetDefaultTechnician: function (row, viewbagDefaultTechnicianUID) {
        const self = this;
        let tecUid = viewbagDefaultTechnicianUID;
        let tecText = '';

        if ($('input#CheckTechnician').is(':checked')) {
            const firstProcedureTecUid = $('table#selectedProcedures tr.selectedProcedureItem').first().find('input.tecUid').val();
            const firstProcedureTecText = $('table#selectedProcedures tr.selectedProcedureItem').first().find('input.tecText').val();

            if (firstProcedureTecUid && firstProcedureTecUid !== "") {
                tecUid = firstProcedureTecUid;
                tecText = firstProcedureTecText;

                row.find('.tecUid').val(tecUid);
                row.find('.tecUid').attr('value', tecUid);
                row.find('.tecText').val(tecText);
                row.find('.tecText').attr('value', tecText);
                return Promise.resolve();
            }
        }

        if (viewbagDefaultTechnicianUID && viewbagDefaultTechnicianUID !== "" && viewbagDefaultTechnicianUID !== "0") {

            if (self.isDefaultTechnicianFetched && self.defaultTechnicianUID === viewbagDefaultTechnicianUID) {
                // Use the stored values
                row.find('.tecUid').val(self.defaultTechnicianUID);
                row.find('.tecUid').attr('value', self.defaultTechnicianUID);
                row.find('.tecText').val(self.defaultTechnicianText);
                row.find('.tecText').attr('value', self.defaultTechnicianText);
                return Promise.resolve();
            }

            const promise = fetch('/legacy/Json/GetTechnicianName?' +
                new URLSearchParams({ ID: viewbagDefaultTechnicianUID }),
                {
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }
            )
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    if (data.AllOk) {
                        // Store in variables for reuse
                        self.defaultTechnicianUID = viewbagDefaultTechnicianUID;
                        self.defaultTechnicianText = data.TechnicianName;
                        self.isDefaultTechnicianFetched = true;

                        tecUid = self.defaultTechnicianUID;
                        tecText = self.defaultTechnicianText;
                    }

                    row.find('.tecUid').val(tecUid);
                    row.find('.tecUid').attr('value', tecUid);
                    row.find('.tecText').val(tecText);
                    row.find('.tecText').attr('value', tecText);
                })
                .catch(function(error) {
                    console.error('Failed to get technician name:', error);

                    row.find('.tecUid').val(tecUid || "");
                    row.find('.tecUid').attr('value', tecUid || "");
                    row.find('.tecText').val(tecText || "");
                    row.find('.tecText').attr('value', tecText || "");
                });

            SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);
            return promise;
        } else {
            row.find('.tecUid').val(tecUid || "");
            row.find('.tecUid').attr('value', tecUid || "");
            row.find('.tecText').val(tecText || "");
            row.find('.tecText').attr('value', tecText || "");
            return Promise.resolve();
        }
    },
    /*
        Export formats
    */
    LoadPhyscianExportFormatsForApplicantType: function(appType) {
        const longAppType = {App: 'Applicant', AppCC: 'Applicant_CC', AppCC2: 'Applicant_CC_2'}[appType];

        const applicantPhysicianID = $('input#' + longAppType + '_UID').attr('value');
        const applicantName = $('input#' + longAppType + '_Text').attr('value');
        const applicantContactInformationID = $('#' + longAppType + '_ContactID').val();

        if ((!applicantPhysicianID || parseInt(applicantPhysicianID) === 0) && !applicantContactInformationID)
            return Promise.resolve();

        return SharedOrderFunctions.LoadPhyscianExportFormats(appType, applicantPhysicianID, applicantName, applicantContactInformationID);
    },
    LoadPhyscianExportFormats: function (app, physicianID, physicianName, physicianContactInfoID) {
        const CC = app === 'AppCC';
        const CC2 = app === 'AppCC2';

        const promise = new Promise(function (resolve) {
            SharedOrderFunctions.DeletePhysicianExportFormats(app);
            resolve()
        })
        .then(function () {
            return fetch("/legacy/Orders/FindPhysExportFormats?" +
                new URLSearchParams({
                    id: physicianID,
                    contactID: physicianContactInfoID,
                    CC: CC,
                    CC2: CC2
                }),
                {
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }
            )
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            // Set physician name in corresponding header
            $('#tblPhysExportFormats' + app + ' span.namePhysician').text(physicianName);
            _.forEach(data, function (exportFormatData) {
                const exportFormatHTML = SharedOrderFunctions.GeneratePhyscianExportFormat(exportFormatData, app);
                $('#tblPhysExportFormats' + app).append(exportFormatHTML);
            });

            SharedOrderFunctions.SortPhysExportFormats(app);
        });

        SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);

        return promise;
    },
    GeneratePhyscianExportFormat: function(dataObject, app) {
        const data  = dataObject;

        const ID = data.ID;
        const physicianID = data.Physician_UID;
        const exportFormatID = data.ExportFormat_UID;
        const exportFormatName = data.ExportFormat_Name;
        const useInPartial = data.UseInPartial;
        const defaultWhenNoPEF = data.DefaultWhenNoPEF;
        const parameters = data.Parameters;
        const triggerStatus = data.TriggerStatus;
        const orderTriggerStatusID = data.OrderTriggerStatus_UID;
        const reportTriggerStatusID = data.ReportTriggerStatus_UID;

        let toAppend = '<tr class="efRecord"><td class="pr35">';
        toAppend += exportFormatName;
        if (useInPartial) {
            // Fix resourcePartialReport so it is passed
            toAppend += ' (' + $("<div/>").html(resourcePartialReport).text() + ')';
        }
        toAppend += '<input type="hidden" class="physEFName" value="' + exportFormatName + '" name="' + app + 'ListPhysExportFormat[0].ExportFormat_Name" />';
        toAppend += '<input type="hidden" class="physEFEFID" value="' + exportFormatID + '" name="' + app + 'ListPhysExportFormat[0].ExportFormat_UID" />';
        toAppend += '<input type="hidden" class="physEFID" value="' + ID + '" name="' + app + 'ListPhysExportFormat[0].ID" />';
        toAppend += '<input type="hidden" class="physEFPartial" value="' + useInPartial + '" name="' + app + 'ListPhysExportFormat[0].UseInPartial" />';
        toAppend += '<input type="hidden" class="physEFDefault" value="' + defaultWhenNoPEF + '" name="' + app + 'ListPhysExportFormat[0].DefaultWhenNoPEF" />';
        toAppend += '<input type="hidden" class="physUID" value="' + physicianID + '" name="' + app + 'ListPhysExportFormat[0].Physician_UID" />';
        toAppend += '</td>';
        toAppend += '<td class="pr30">' + parameters + '<input type="hidden" class="physEFParameters" value="' + parameters + '" name="' + app + 'ListPhysExportFormat[0].Parameters" /></td>';
        toAppend += '<td class="pr30">';
        toAppend += triggerStatus;
        toAppend += '<input type="hidden" class="triggerStatus" value="' + triggerStatus + '" name="' + app + 'ListOrderExportFormat[0].TriggerStatus" />';
        toAppend += '<input type="hidden" class="physEFOrderTriggerStatus" value="' + orderTriggerStatusID + '" name="' + app + 'ListPhysExportFormat[0].OrderTriggerStatus_UID"/>';
        toAppend += '<input type="hidden" class="physEFReportTriggerStatus" value="' + reportTriggerStatusID + '" name="' + app + 'ListPhysExportFormat[0].ReportTriggerStatus_UID" />';
        toAppend += '</td>';
        toAppend += '<td class="pr5 delete">resourceDelete</td></tr>';

        return toAppend;
    },
    SortProceduresExportFormats: function (e) {
        const promises = [];
        const formats = $('#tblProcedureExportFormat').find('tr.procedureExportFormatRow');
        $.each(formats, function (i, obj) {
            promises.push(new Promise(function(resolve) {
                $(formats[i]).find('input.procedureEFProcedureName').attr('name', 'ListProcedureExportFormat[' + i + '].ProcedureName');
                $(formats[i]).find('input.procedureEFProcedureID').attr('name', 'ListProcedureExportFormat[' + i + '].ProcedureID');
                $(formats[i]).find('input.procedureEFName').attr('name', 'ListProcedureExportFormat[' + i + '].Name');
                $(formats[i]).find('input.procedureEFID').attr('name', 'ListProcedureExportFormat[' + i + '].ID');
                $(formats[i]).find('input.procedureEFLinkID').attr('name', 'ListProcedureExportFormat[' + i + '].LinkID');
                $(formats[i]).find('input.procedureEFProcedureLinkID').attr('name', 'ListProcedureExportFormat[' + i + '].ProcedureLinkID');
                $(formats[i]).find('input.procedureEFDone').attr('name', 'ListProcedureExportFormat[' + i + '].Done');
                $(formats[i]).find('input.procedureEFUID').attr('name', 'ListProcedureExportFormat[' + i + '].OrderHasExport_UID');
                $(formats[i]).find('input.procedureEFPartial').attr('name', 'ListProcedureExportFormat[' + i + '].UseInPartial');
                $(formats[i]).find('input.triggerStatus').attr('name', 'ListProcedureExportFormat[' + i + '].TriggerStatus');
                $(formats[i]).find('input.procedureEFOrderTriggerStatus').attr('name', 'ListProcedureExportFormat[' + i + '].OrderTriggerStatus_UID');
                $(formats[i]).find('input.procedureEFReportTriggerStatus').attr('name', 'ListProcedureExportFormat[' + i + '].ReportTriggerStatus_UID');
                resolve();
            }));
        });
        return new Promise(function(resolve) { Promise.all(promises).then(function() {resolve();})});
    },
    DeletePhysicianExportFormats: function (app) {
        $('#tblPhysExportFormats' + app + ' tr.efRecord').remove();
        $('#tblPhysExportFormats' + app + ' span.namePhysician').text(resourceEmpty);
    },
    GetInvoiceInformationShared: function(resetCustomTotals, patientDOB, patientGender, patientID, orderUID,
                                          amountPatientEdited, totalAmountEdited, invoiceMethod, companyFilled,
                                          radiologistChanged, manuallyAddedNomens) {
        resetCustomTotals = resetCustomTotals || false;
        if (resetCustomTotals) {
            amountPatientEdited = false;
            totalAmountEdited = false;
        }

        const onDuty = $('input#OnDuty').prop('checked');
        const wigw = $('input#WIGW').prop('checked');
        const gmd = $('input#PatientGMD').prop('checked');
        let cg1cg2 = "";
        if($('#editHICG1CG2').children()[0]) { cg1cg2 = $('#editHICG1CG2').children()[0].innerText; }
        const ambulantHospitalized = $('input[type="radio"][name="AmbulantHospitalized"]:checked').val();
        const dateOfImplementation = $('input#DateOfImplementation').val();
        const gender = patientGender === '0' ? 'M' : 'F';
        const freeOfContribution = $('input#FreeOfContribution').prop('checked');
        const freeOfCharge = $('input#FreeOfCharge').prop('checked');
        let newAmountPatient = null;
        if (amountPatientEdited) {
            newAmountPatient = $('input[name="NewAmountPatient"]').val();
        }
        let newTotalAmount = null;
        if (totalAmountEdited) {
            newTotalAmount = $('input[name="NewTotalAmount"]').val();
        }

        const invoiceExtraOption = $('select[name="InvoiceExtraOption"]').val();
        const proofOfPayment = $('input#ProofOfPayment').prop('checked');

        const invoiceCertificate = $('input#InvoiceCertificate').prop('checked');
        const cumulRules = $('input#InvoiceCumulRules').prop('checked');

        const invoiceSupplement = $('input#InvoiceSupplement').prop('checked');

        if (invoiceMethod != null) {
            invoiceMethod = $('input[type="radio"][name="InvoicePaymentMethod"]:checked').val();
        }

        if ($('select#InvoiceSituation_UID').val() === 6) {
            if ($('#InvoiceCompany_Text').val() != "") {
                companyFilled = true;
            }
        }

        const claustrophobia = $('input#InvoiceClaustrophobia').prop('checked');

        let procedures = [];
        $('table#selectedProcedures tr.selectedProcedureItem').each(function (i, x) {
            if ($(x).find('select.statusDrop').val() != "10") {
                procedures.push({
                    ProcedureID: $(x).find('input.id').val(),
                    Code: $(x).find('input.code').val(),
                    FullCode: $(x).find('input.fullCode').val(),
                    Color: $(x).find('input.color').val(),
                    Modality_Text: $(x).find('input.modality').val(),
                    RadiologistID: $(x).find('input.radUid').val(),
                    DateTimePlanned: $(x).find('input.procPlanned').val(),
                    RoomID: $(x).find('input.roomUID').val(),
                });
            }
        });

        let products = [];
        $('table#selectedProducts tr.selectedProductItem').each((i, x) => {
            let amount = Number($(x).find('.productAmount').val());
            const productID = Number($(x).find('input.productUID').val());
            const productCode = $(x).find('input.productCode').val();
            const procedureID = Number($(x).find('input.productFromProcedureUID').val());
            const orderProcedureID = Number($(x).find('input.productFromOrderProcedureUID').val());
            const procedureCode = $(x).find('input.productFromProcedureCode').val();
            products = [...products, ...Array(amount).fill({
                ProductID: productID,
                ProductCode: productCode,
                FromProcedureID:  procedureID,
                FromProcedureCode: procedureCode,
                FromOrderProcedureID: orderProcedureID,
            })];
        });

        const func = () => {
            const promise = fetch("/legacy/Orders/GetInvoiceInformation",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    PatientID: patientID,
                    FreeOfContribution: freeOfContribution,
                    FreeOfCharge: freeOfCharge,
                    OnDuty: onDuty,
                    WIGW: wigw,
                    GMD: gmd,
                    CG1CG2: cg1cg2,
                    AmbulantHospitalized: ambulantHospitalized,
                    DOB: patientDOB,
                    DateOfImplementation: dateOfImplementation,
                    Gender: gender,
                    Procedures: procedures,
                    Products: products,
                    InvoicePaymentMethod: invoiceMethod,
                    NewAmountPatient: newAmountPatient,
                    NewTotalAmount: newTotalAmount,
                    IsRefresh: resetCustomTotals,
                    InvoiceExtraOption: invoiceExtraOption,
                    ProofOfPayment: proofOfPayment,
                    InvoiceSituation_UID: $('select#InvoiceSituation_UID').val(),
                    InvoiceCertificate: invoiceCertificate,
                    CumulRules: cumulRules,
                    CompanyFilled: companyFilled,
                    InvoiceSupplement: invoiceSupplement,
                    OrderUID: orderUID,
                    Claustrophobia: claustrophobia,
                    CustomHonorarium: $('#CustomHonorarium').val(),
                    CustomWIGW: $('#CustomWIGW').val(),
                    CustomOther: $('#CustomOther').val(),
                    CustomPractice: $('#CustomPractice').val(),
                    VisitMovementID: $('#visitMovementUID').val(),
                    RadiologistChanged: radiologistChanged,
                    manuallyAddedNomenclatures: manuallyAddedNomens
                })
            }
            )
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                SharedOrderFunctions.setPaymentMethod(data.PaymentMethod);
                SharedOrderFunctions.setCertificateNumber(data.InvoiceCertificateNumber);
                sessionStorage.setItem('OrderNomenclatureGridInvoiceModel' + viewbagUniquePrefix, JSON.stringify(data));
                sessionStorage.setItem('OrderNomenclatureGridListProcedureItems' + viewbagUniquePrefix, JSON.stringify(procedures));
                window.loadOrderNomenclatureGrid(viewbagUniquePrefix, SharedOrderFunctions.GetInvoiceInformation);
                window.loadInvoiceRemarks(viewbagUniquePrefix);

            });

            return promise;
        }

        SharedOrderFunctions.saveChecker.queueSaveBlockingAction(func);

        return func;
    },
    UpdatePaymentPlan: function () {
        const dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
        const dueDate = moment($('#DateOfImplementation').val(), "DD/MM/YYYY HH:mm").add(viewbagDefaultPaymentPlanDueDateDays, 'days').format("DD/MM/YYYY");
        const totalAmount = SharedOrderFunctions.GetEffectiveInvoiceTotal();
        let stillToPay = 0;

        let amountPaymentPlan = 0;
        $('table.donePaymentPlan input.hiddenDonePaymentPlanValue').each(function (e) {
            amountPaymentPlan = amountPaymentPlan + parseFloat($(this).val());
        });
        dialog.find('dd#totalDonePaymentsPlan span').text(amountPaymentPlan.toFixed(2));

        if ($.isNumeric(amountPaymentPlan)) {
            stillToPay = totalAmount - parseFloat(amountPaymentPlan);
        } else {
            stillToPay = totalAmount;
        }

        if (stillToPay > 0) {
            let donePayments = $('dd#donePaymentsPlan table.donePaymentPlan');

            const paymentPlanLength = $(".donePaymentPlan tr").length  - 1;
            let lineToAdd = '<tr class="paymentPlanRow"><td>&euro; <span class="donePaymentPlanValue">' + stillToPay.toFixed(2).toString() + '</span>';
            lineToAdd += '<input name="ListPaymentPlanItem[' + paymentPlanLength + '].Amount" type="hidden" class="hiddenDonePaymentPlanValue" value="' + stillToPay.toFixed(2).toString() + '"></td>';
            lineToAdd += '<td><span class="donePaymentPlanDueDate">' + dueDate + '</span>';
            lineToAdd += '<input name="ListPaymentPlanItem[' + paymentPlanLength + '].DueDate" type="hidden" class="hiddenDonePaymentPlanDueDate" value="' + dueDate + '"></td>';
            lineToAdd += '<td class="delete" title="' + resourceDelete + '">&nbsp;</td></tr>';

            donePayments.append(lineToAdd);

            SharedOrderFunctions.CalculateInvoiceAmounts();
            SharedOrderFunctions.SortPaymentPlanItems();
        }

        if (stillToPay < 0) {
            let amountToRemove = Math.abs(stillToPay);
            if (amountToRemove > 0) {
                while (amountToRemove > 0) {
                    const amountOfLastPayment = parseFloat($('dd#donePaymentsPlan table.donePaymentPlan tr:last .hiddenDonePaymentPlanValue').val());

                    if (amountToRemove < amountOfLastPayment) {
                        $('dd#donePaymentsPlan table.donePaymentPlan tr:last .hiddenDonePaymentPlanValue').val((amountOfLastPayment - amountToRemove).toFixed(2).toString());
                        $('dd#donePaymentsPlan table.donePaymentPlan tr:last td .donePaymentPlanValue').html((amountOfLastPayment - amountToRemove).toFixed(2).toString());
                        amountToRemove = 0;
                    } else {
                        amountToRemove = amountToRemove - amountOfLastPayment;
                        $('dd#donePaymentsPlan table.donePaymentPlan tr:last').remove();
                    }
                }
            }

            SharedOrderFunctions.CalculateInvoiceAmounts();
            SharedOrderFunctions.SortPaymentPlanItems();
        }
    },
    
    GetEffectiveInvoiceTotal: function () {
        const rawTotal = parseFloat($('#invoiceSummary div.activeSummaryField input.cleanInput').val());
        const prepaymentAmount = SharedOrderFunctions.prepaymentAmount;
        const hasPrepayment = prepaymentAmount != null && !isNaN(prepaymentAmount);
        if (hasPrepayment) {
            return this.ApplyRoundingIfNeeded(prepaymentAmount);
        }
        return rawTotal;
    },
    CalculateInvoiceAmounts: function (e) {
        const dialogInvoice = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
        dialogInvoice.find('span.validation').text("");
        dialogInvoice.find('span.validation').hide();
        const totalAmount = $('#invoiceSummary div.activeSummaryField input.cleanInput').val();
        dialogInvoice.find('dd#totalAmount span').text(totalAmount);
        const stillToPaySpan = dialogInvoice.find('dd#stillToPay span');
        const totalDonePayments = dialogInvoice.find('dd#totalDonePayments span');

        let totalAlreadyPayed = 0.00;
        $('table.donePayment input.hiddenDonePaymentValue').each(function (e) {
            totalAlreadyPayed = totalAlreadyPayed + parseFloat($(this).val(), 10);
        });

        totalAlreadyPayed = parseFloat(totalAlreadyPayed, 10).toFixed(2);
        let amountTotalAmount = parseFloat(totalAmount, 10).toFixed(2);
        let amountStillToPay = amountTotalAmount - totalAlreadyPayed;

        amountStillToPay = this.ApplyRoundingIfNeeded(amountStillToPay);

        const prepaymentAmount = SharedOrderFunctions.prepaymentAmount;
        const hasPrepayment = prepaymentAmount != null && !isNaN(prepaymentAmount);
        if (hasPrepayment) {
            amountStillToPay = this.ApplyRoundingIfNeeded(prepaymentAmount - totalAlreadyPayed);
        }

        stillToPaySpan.text(amountStillToPay.toFixed(2).toString() + (hasPrepayment ? ' (' + resourceReceivedFromBillingSystem + ')' : ''));
        totalDonePayments.text(totalAlreadyPayed.toString());

        if (amountStillToPay != 0) {
            $('input#AddPaymentInput').val(amountStillToPay.toFixed(2).toString());
            dialogInvoice.find('.toAddPayment').show();
            stillToPaySpan.removeClass('allPayed');
        } else {
            $('input#AddPaymentInput').val("");
            stillToPaySpan.addClass('allPayed');
            dialogInvoice.find('.toAddPayment').hide();
        }

        let totalPaymentPlan = 0;
        $('table.donePaymentPlan input.hiddenDonePaymentPlanValue').each(function (e) {
            totalPaymentPlan = totalPaymentPlan + parseFloat($(this).val());
        });

        dialogInvoice.find('dd#totalDonePaymentsPlan span').text(totalPaymentPlan.toFixed(2));

        const effectiveTotal = SharedOrderFunctions.GetEffectiveInvoiceTotal();
        const amountEffectiveTotal = parseFloat(effectiveTotal, 10).toFixed(2);

        if (parseFloat(totalPaymentPlan.toFixed(2)) === parseFloat(amountEffectiveTotal)) {
            dialogInvoice.find('.toAddPaymentPlan').hide();
            $('input#AddPaymentPlanInput').val("");
            $('input#AddPaymentPlanDate').val("");
        } else {
            dialogInvoice.find('.toAddPaymentPlan').show();
            const stillToPaymentPlan = (parseFloat(effectiveTotal) - totalPaymentPlan).toFixed(2);
            $('input#AddPaymentPlanInput').val(stillToPaymentPlan);
            const dueDateMoment = moment($('input#DateOfImplementation').val(), "DD/MM/YYYY");
            if (dueDateMoment != null && dueDateMoment.isValid()) {
                $('input#AddPaymentPlanDate').val(dueDateMoment.add(viewbagDefaultPaymentPlanDueDateDays, 'days').format("DD/MM/YYYY"));
            }
        }

        SharedOrderFunctions.ShowPrepaymentError();
    },
    prepaymentOrderId: null,
    prepaymentAmount: null,
    prepaymentError: null,

    IsViaductPrepaymentConfigured: function () {
        return typeof viewbagViaductPrepaymentEnabled !== 'undefined' && viewbagViaductPrepaymentEnabled === true;
    },

    ShowPrepaymentError: function () {
        if (!SharedOrderFunctions.prepaymentError) {
            return;
        }
        const validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('#standaloneValidation');
        validation.text(SharedOrderFunctions.prepaymentError);
        validation.show();
    },

    FetchPrepaymentAmount: function (orderId) {
        SharedOrderFunctions.prepaymentAmount = null;
        SharedOrderFunctions.prepaymentError = null;
        return fetchPrepaymentAmount(viewbagUniquePrefix, orderId)
            .then(function (result) {
                SharedOrderFunctions.prepaymentAmount = result && result.amount != null
                    ? result.amount
                    : null;
                SharedOrderFunctions.prepaymentError = result && result.error
                    ? result.error
                    : null;
                return result;
            });
    },

    // This is used because it can happen that UI elements in Invoice tab are not rendered yet that are used for calculations in SharedOrderFunctions.CalculateInvoiceAmounts. So this method handle that
    ShowConfirmInvoiceDialog: function (retryCount = 0) {
        if (retryCount >= 10) {
            return;
        }

        if ($('#invoiceSummary').length > 0) {
            const openAndCalculate = function () {
                $('#dialogConfirmInvoice' + viewbagUniquePrefix).dialog('open');
                SharedOrderFunctions.CalculateInvoiceAmounts();
                SharedOrderFunctions.UpdatePaymentPlan();
            };

            if (SharedOrderFunctions.prepaymentOrderId && SharedOrderFunctions.IsViaductPrepaymentConfigured()) {
                SharedOrderFunctions.FetchPrepaymentAmount(SharedOrderFunctions.prepaymentOrderId)
                    .then(openAndCalculate);
            } else {
                openAndCalculate();
            }
            return;
        }

        setTimeout(function () {
            SharedOrderFunctions.ShowConfirmInvoiceDialog(retryCount + 1);
        }, 500);
    },
    SortPaymentPlanItems: function () {
        const paymentsPlan = $('#donePaymentsPlan table.donePaymentPlan').find('.paymentPlanRow');
        $.each(paymentsPlan, function (index, obj) {
            $(paymentsPlan[index]).find('input.hiddenDonePaymentPlanValue').attr('name', 'ListPaymentPlanItem[' + index + '].Amount');
            $(paymentsPlan[index]).find('input.hiddenDonePaymentPlanDueDate').attr('name', 'ListPaymentPlanItem[' + index + '].DueDate');
            $(paymentsPlan[index]).find('input.hiddenDonePaymentPlanID').attr('name', 'ListPaymentPlanItem[' + index + '].ID');
        });
    },
    LocallyPrintEF: (orderID, efID) => {
        fetch('/legacy/Export/PrintExportFormat', { method: 'POST', body: new URLSearchParams({ orderID, efID }) })
        .then( res => res.blob())
        .then( blob => {
            if (blob.type === 'application/json') {
                blob.text().then(txt => {
                    const json = JSON.parse(txt);
                    if (json.Ok) return alert(Resources.NoPDFToGenerate);
                    alert(Resources.CouldNotGeneratePDF);
                    console.error(`PrintExportFormat error with OrderID ${orderID} and EF ID ${efID}`, json);
                });
            }
            else {
                const file = window.URL.createObjectURL(blob);
                window.open(file, '_blank');
            }
        });
    },
    ValidatePaymentOnConfirmInvoice: (viewbagUniquePrefix) => {
        if (SharedOrderFunctions.ValidatePaymentPlan()) {
            $('input#ConfirmInvoice').val("true");
            $('input#ConfirmInvoice').attr('value', "true");
            $('input#ConfirmPrepayment').val("false");
            $('input#ConfirmPrepayment').attr('value', "false");

            $('#btnConfirmInvoice' + viewbagUniquePrefix).prop('disabled', true);

            SharedOrderFunctions.ConfirmInvoiceFunctionality();
        } else {
            const validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('span.validation');
            validation.text(resourceInvalidPaymentPlan);
            validation.show();
            return false;
        }
    },
    ConfirmInvoice: (viewbagUniquePrefix) => {
        const number = $('input#InvoiceCertificateNumber').val();
        const recommendedNumber = $('.recommendedCertificateNumber').val();
        if(number !== recommendedNumber) {
            fetch("/legacy/Invoices/CheckIfCertificateNumberExist?number=" + number, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.CertificateNumberAlreadyExists === true) {
                        console.warn('Certificate number already exists');
                        const validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('span.validation');
                        validation.text(data.Message);
                        validation.show();
                    }
                    else {
                        SharedOrderFunctions.ValidatePaymentOnConfirmInvoice(viewbagUniquePrefix);
                    }
                })
                .catch(error => {
                    console.error("An error occurred:", error);
                });
        }
        else {
            SharedOrderFunctions.ValidatePaymentOnConfirmInvoice(viewbagUniquePrefix);
        }
    },
    previewFile: function(fileName, dialog, container) {
        $(dialog).dialog('open');
        let el;
        if (fileName.match(/pdf/))
           el = `<iframe src="/legacy/OrdersNoSession/PreviewFile?fileName=${fileName}" />`;
        else
            el = `<img src="/legacy/OrdersNoSession/PreviewFile?fileName=${fileName}" />`;
        container.html(el);
    },
    patientInfoEditDialog: function(elementID, dialogID, validationCallback, afterSuccessCallBack) {
        const dialogDivHolder = $(dialogID);
        const validation = dialogDivHolder.find('span.validation');
        const inputElement = dialogDivHolder.find('dl dd input');
        const value = $.trim(inputElement.val());

        // Always allow empty input
        const isEmpty = value === '';
        const issue = validationCallback && validationCallback(value);
        if (issue) {
            validation.show();
            validation.text(issue);
            return;
        }

        validation.hide();

        const element = $(elementID);
        const elementInUI = $(element).find("span.value");
        const hiddenInputElement = $(element).find("input");

        const newValue = isEmpty ? htmlDecode(resourceNone) : value;
        elementInUI.removeClass('none').removeClass('noneRequired');
        elementInUI.text(newValue);
        hiddenInputElement.text(newValue);
        hiddenInputElement.val(newValue);

        dialogDivHolder.dialog("close");

        afterSuccessCallBack && afterSuccessCallBack(value);
    },
    registerPatientInfoClickHandler: function(clickElementID, dialogID, viewbagUniquePrefix) {
        $(clickElementID).on('click', function (e) {
            if (!$('div#subPageContent').hasClass('disabled') && !$('div#subPageContent').hasClass('disabledNone')) {
                $(dialogID + viewbagUniquePrefix).dialog("open");
                $(dialogID + viewbagUniquePrefix).find('span.validation').hide();
                var currentValue = $(clickElementID).find('input').val();
                currentValue = currentValue === htmlDecode(resourceNone) ? "" : currentValue;
                $(dialogID + viewbagUniquePrefix).find('dl dd input').val(currentValue);
            }
        });
    },
    registerPatientInfoDialogs: function(viewbagUniquePrefix) {
        // INSZ
        SharedOrderFunctions.registerPatientInfoClickHandler('#editHIINSZ', '#divEditHIINSZ', viewbagUniquePrefix);
        $('button#btnCloseEditHIINSZ' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditHIINSZ' + viewbagUniquePrefix).dialog("close");
        });
        $('button#btnSaveAndCloseEditHIINSZ' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.patientInfoEditDialog('#editHIINSZ', '#divEditHIINSZ' + viewbagUniquePrefix,
            (value) => {
                if (value === '')
                    return htmlDecode(resourceErrorIsRequired);
                if (value.length > 20)
                    return htmlDecode(resourceErrorLength20);
            });
        });

        // CG1CG2
        SharedOrderFunctions.registerPatientInfoClickHandler('#editHICG1CG2', '#divEditHICG1CG2', viewbagUniquePrefix);
        $('button#btnCloseEditHICG1CG2' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditHICG1CG2' + viewbagUniquePrefix).dialog("close");
        });
        $('button#btnSaveAndCloseEditHICG1CG2' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.patientInfoEditDialog('#editHICG1CG2', '#divEditHICG1CG2' + viewbagUniquePrefix,
                (value) => {
                    if (value === '')
                        return htmlDecode(resourceErrorIsRequired);
                    if (!SharedMainFunctions.cg1cg2IsValid(value))
                        return htmlDecode(resourceErrorValidCG1CG2);
                },
                (value) => {
                    SharedOrderFunctions.setCG1CG2(value);
                }
            );
        });

        // Length
        SharedOrderFunctions.registerPatientInfoClickHandler('#editLength', '#divEditLength', viewbagUniquePrefix);
        $('button#btnCloseEditLength' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditLength' + viewbagUniquePrefix).dialog("close");
        });
        $('button#btnSaveAndCloseEditLength' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.patientInfoEditDialog('#editLength', '#divEditLength' + viewbagUniquePrefix,
            (value) => {
                if (!value.match(/^[0-9]+$/))
                    return 'not a valid length';
            });
        });

        // Weight
        SharedOrderFunctions.registerPatientInfoClickHandler('#editWeight', '#divEditWeight', viewbagUniquePrefix);
        $('button#btnCloseEditWeight' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditWeight' + viewbagUniquePrefix).dialog("close");
        });
        $('button#btnSaveAndCloseEditWeight' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.patientInfoEditDialog('#editWeight', '#divEditWeight' + viewbagUniquePrefix,
            (value) => {
                if (!value.match(/^[0-9]+$/))
                    return 'not a valid weight';
            });
        });
    },
    setCG1CG2: function(cg1cg2) {
        if (!SharedMainFunctions.cg1cg2IsValid(cg1cg2))
            throw new Error(`${cg1cg2} is not a valid cg1cg2`);

        SharedOrderFunctions.setInvoicePaymentOptionsForCG1CG2(cg1cg2);
        const isWIGW = SharedMainFunctions.isWIGW(cg1cg2);

        $('input#WIGW').prop("checked", isWIGW);

        // Keep supplement checkboxes in sync with the live WIGW state on a CG1/CG2 change.
        // The else re-enable is safe: setCG1CG2 only runs in edit mode (unreachable once the
        // invoice is confirmed), where the only other disable is itself WIGW-render-time driven.
        if (typeof viewbagRemoveSupplementIfWIGW !== 'undefined' && viewbagRemoveSupplementIfWIGW === 'True') {
            if (isWIGW) {
                $('#InvoiceSupplement').prop('checked', false).prop('disabled', true);
                $('#AutoUpdateSupplement').prop('checked', false).prop('disabled', true);
            } else {
                $('#InvoiceSupplement').prop('disabled', false);
                $('#AutoUpdateSupplement').prop('disabled', false);
            }
        }

        SharedOrderFunctions.GetInvoiceInformation(true);
    },
    setGMD: function(hasGMD) {
        $('input#PatientGMD').prop("checked", hasGMD);
        SharedOrderFunctions.GetInvoiceInformation(true);
    },
    setInvoicePaymentOptionsForCG1CG2: function(cg1cg2) {
        var incorrectInsurance = !!$.trim(cg1cg2).match(/000\/[0-9]{3}$/);

        // Disable third party options if cg1/cg2 is not valid
        $('input[name=InvoicePaymentMethod][value="2"]:radio').prop('disabled', incorrectInsurance);
        $('input[name=InvoicePaymentMethod][value="4"]:radio').prop('disabled', incorrectInsurance);

        if (!incorrectInsurance)
            return;

        // Make sure any previously selected paymentmethod is still enabled, else default to direct payment
        const checkedPaymentMethod = $('input[name=InvoicePaymentMethod][checked]:radio');
        const isEnabled = !!$(checkedPaymentMethod).prop('disabled');

        if (!isEnabled) {
            $(checkedPaymentMethod).removeAttr('checked');
            $('input[name=InvoicePaymentMethod][value="1"]:radio').prop('checked', true);
        }
    },
    validateOrderImplementationDate: function(input, validateOrderImplementationAjax, useProducts, patientID) {
        const validation = $(this).parent().find('span.field-validation-valid');
        validation.addClass('field-validation-error');
        if (validateOrderImplementationAjax && validateOrderImplementationAjax.readyState != 4) {
            validateOrderImplementationAjax.abort();
        }
        validateOrderImplementationAjax = $.ajax({
            type: "GET",
            url: "/legacy/Json/ValidateDateTimeFormat",
            data: {
                DateTime: input.val(),
                CheckOnDuty: true
            },
            async: false,
            success: function (data) {
                if (data.IsValid) {
                    $('#scanOrder').removeClass('btnDisabled');
                    $('#scanOrder').tooltip('disable');
                    if (data.SetOnDuty) {
                        if (data.OnDuty) {
                            $('input#OnDuty').prop('checked', true);
                            $('input#OnDuty').attr('checked', 'checked');
                            if (viewbagUncheckSupplementsWhenOnDuty == "True") {
                                $('#InvoiceSupplement').prop('checked', false);
                            }
                        } else {
                            $('input#OnDuty').prop('checked', false);
                            $('input#OnDuty').removeAttr('checked');
                        }
                        $('input#OnDutyLevel').val(data.OnDutyLevel);
                        $('input#OnDutyLevelValue').val(data.OnDutyLevelValue);
                        if (data.OnDutyLevel != 'N') {
                            $('span#OnDutyLevelValueSpan').text(htmlDecode(data.OnDutyLevelValue));
                        } else {
                            $('span#OnDutyLevelValueSpan').text("");
                        }

                        SharedOrderFunctions.checkOnDuty();
                    }

                    SharedOrderFunctions.recalculateLotNumbers(useProducts);
                    SharedOrderFunctions.reloadParticularities(patientID);

                    validation.hide();
                    input.removeClass('error');

                    const currentDate = input.val().split(' ')[0];
                    const currentTime = input.val().split(' ')[1];
                    $('.procImplementation, .procPlanned').each(function (i, y) {
                        const procInput = $(y).val();
                        const procDate = procInput.split(' ')[0];
                        const procTime = procInput.split(' ')[1];
                        if (procDate != currentDate) {
                            //ONLY UPDATE THOSE BEFORE ORDER DATE
                            const mOrder = moment(currentDate, 'DD/MM/YYYY');
                            const mProc = moment(procDate, 'DD/MM/YYYY');
                            if (mOrder != null && mOrder.isValid() && mProc != null && mProc.isValid()) {
                                if (mProc.isBefore(mOrder) || mProc.diff(mOrder, 'days') >= 7) {
                                    $(y).removeClass('original');
                                    if (procTime === undefined) {
                                        $(y).val(currentDate + ' ' + currentTime);
                                        $(y).attr('value', currentDate + ' ' + currentTime);
                                    } else {
                                        $(y).val(currentDate + ' ' + procTime);
                                        $(y).attr('value', currentDate + ' ' + procTime);
                                    }
                                    $(y).addClass('changed');
                                    $(y).removeClass('error');
                                }
                            } else if (mProc == null || procTime === undefined) {
                                $(y).removeClass('original');
                                $(y).val(currentDate + ' ' + currentTime);
                                $(y).attr('value', currentDate + ' ' + currentTime);
                                $(y).addClass('changed');
                                $(y).removeClass('error');
                            }
                        }
                    });

                    const removeChangedFromDateTimeProcedures = function () {
                        $('.procImplementation').removeClass('changed');
                        $('.procImplementation').addClass('original');
                    };
                    setTimeout(removeChangedFromDateTimeProcedures, 1500);

                    const orderPresciption = $('#DateOfPrescription');
                    const dateOrderPresciption = orderPresciption.val();
                    orderPresciption.removeClass('original');

                    const mImpl = moment(currentDate, "DD/MM/YYYY");
                    const mPres = moment(dateOrderPresciption, "DD/MM/YYYY");
                    if (mImpl.isValid() && mPres.isValid()) {
                        if (mImpl.isBefore(mPres) || mImpl.diff(mPres, 'days') >= 7) {
                            orderPresciption.addClass('changed');
                            orderPresciption.val(currentDate);
                            orderPresciption.attr('value', currentDate);
                        }
                    }

                    const removeChangedFromDateTimePrescription = function () {
                        orderPresciption.removeClass('changed');
                        orderPresciption.addClass('original');
                    };
                    setTimeout(removeChangedFromDateTimePrescription, 1500);

                    const dateMX = $('#DateMX');
                    if (mImpl.isValid() && dateMX.length > 0){
                        dateMX.val(currentDate);
                        dateMX.attr('value', currentDate);
                    }

                    const privacyDate = $('#PrivacyDate');
                    if (mImpl.isValid() && privacyDate.length > 0) {
                        privacyDate.val(currentDate);
                        privacyDate.attr('value', currentDate);
                    }

                    if (viewbagUseMotivationLetters && viewbagUseMotivationLetters === 'True') {
                        SharedOrderFunctions.checkMotivationLetters();
                    }

                    SharedOrderFunctions.GetInvoiceInformation();

                } else {
                    validation.text(htmlDecode(resourceErrorDateFormat));
                    validation.show();
                    input.addClass('error');
                    $('#scanOrder').addClass('btnDisabled');
                    $('#scanOrder').tooltip('enable');
                }
            }
        });

        return false;
    },
    recalculateLotNumbers: function(useProducts){
        if (useProducts) {
            RecalculateLotnumbers($('#DateOfImplementation').val());
        }
    },
    reloadParticularities: function(patientID){
        const date = $('#DateOfImplementation').val();
        $.ajax({
            type: "GET",
            url: "/legacy/Orders/GetBriefRemarks",
            dataType: "html",
            async: true,
            data: {
                Patient_UID: patientID,
                Date: date
            },
            success: function (data) {
                $('#remarksDiv').html(data);
            }
        })
    },
    validateProcedureImplementationDate: function(input, validateProcImplementationAjax){
        if (validateProcImplementationAjax && validateProcImplementationAjax.readyState != 4) {
            validateProcImplementationAjax.abort();
        }
        validateProcImplementationAjax = $.ajax({
            type: "GET",
            url: "/legacy/Json/ValidateDateTimeFormat",
            data: {
                DateTime: input.val(),
                CheckOnDuty: true
            },
            async: false,
            success: function (data) {
                if (data.IsValid) {
                    input.removeClass('error');

                    if (data.SetOnDuty) {
                        if (data.OnDuty) {
                            $('input#OnDuty').prop('checked', true);
                            $('input#OnDuty').attr('checked', 'checked');
                            if (viewbagUncheckSupplementsWhenOnDuty == "True") {
                                $('#InvoiceSupplement').prop('checked', false);
                            }
                        } else {
                            $('input#OnDuty').prop('checked', false);
                            $('input#OnDuty').removeAttr('checked');
                        }
                        $('input#OnDutyLevel').val(data.OnDutyLevel);
                        $('input#OnDutyLevelValue').val(data.OnDutyLevelValue);
                        if (data.OnDutyLevel != 'N') {
                            $('span#OnDutyLevelValueSpan').text(htmlDecode(data.OnDutyLevelValue));
                        } else {
                            $('span#OnDutyLevelValueSpan').text("");
                        }

                        SharedOrderFunctions.checkOnDuty();
                    }

                    SharedOrderFunctions.checkDatesWhenProcedureDateChangedInOrder(input);
                } else {
                    input.addClass('error');
                }
            }
        });
    },
    checkDatesWhenProcedureDateChangedInOrder: function (input) {
        let proceduresSameDate = true;
        const orderImplementation = $('#DateOfImplementation');
        const currentDate = input.val().split(' ')[0];
        const currentTime = input.val().split(' ')[1];

        const plannedDateTime = input.parent().find('.procPlanned');
        plannedDateTime.val(currentDate + ' ' + currentTime);
        plannedDateTime.attr('value', currentDate + ' ' + currentTime);

        let earliestProcDate;
        $('.procImplementation').each(function (i, y) {
            const date = $(y).val().split(' ')[0];
            if (currentDate !== date) {
                proceduresSameDate = false;
            }
            if (!earliestProcDate || $(y).val() < earliestProcDate)
                earliestProcDate = $(y).val();
        });

        const procedureDate = input.val();

        if (proceduresSameDate) {
            const orderDate = orderImplementation.val();
            const dateOrderImplementation = orderDate.split(' ')[0];
            const timeOrderImplementation = orderDate.split(' ')[1];
            const orderPresciption = $('#DateOfPrescription');
            const dateOrderPresciption = orderPresciption.val();

            let triggerChange = false;
            let changeDate;
            let changeTime;

            if (procedureDate !== orderDate && procedureDate < orderDate) {
                triggerChange = true;
                changeDate = currentDate;
                changeTime = currentTime;

            } else {
                if (earliestProcDate !== orderDate || $('.procImplementation').length === 1) {
                    triggerChange = true;
                    changeDate = earliestProcDate.split(' ')[0];
                    changeTime = earliestProcDate.split(' ')[1];
                }
            }
            if (triggerChange) {
                orderImplementation.removeClass('original');
                orderPresciption.removeClass('original');

                orderImplementation.addClass('changed');
                if (timeOrderImplementation === undefined) {
                    orderImplementation.val(changeDate + ' ' + changeTime);
                    orderImplementation.attr('value', changeDate + ' ' + changeTime);
                } else {
                    orderImplementation.val(changeDate + ' ' + changeTime);
                    orderImplementation.attr('value', changeDate + ' ' + changeTime);
                }

                orderImplementation.removeClass('error');
                orderImplementation.parent().find('span.field-validation-valid').hide();

                const mImpl = moment(changeDate, "DD/MM/YYYY");
                const mPres = moment(dateOrderPresciption, "DD/MM/YYYY");
                if (mImpl.isValid() && mImpl != null && mPres.isValid() && mPres != null) {
                    if (mImpl.isBefore(mPres) || mImpl.diff(mPres, 'days') >= 7) {
                        orderPresciption.addClass('changed');
                        orderPresciption.val(changeDate);
                        orderPresciption.attr('value', changeDate);
                    }
                }

                const removeChangedFromDateTimeImplementation = function () {
                    orderImplementation.removeClass('changed');
                    orderImplementation.addClass('original');
                    orderPresciption.removeClass('changed');
                    orderPresciption.addClass('original');
                };
                setTimeout(removeChangedFromDateTimeImplementation, 1500);

                $('input#DateOfImplementation').trigger('input');

                if (viewbagUseMotivationLetters && viewbagUseMotivationLetters === 'True') {
                    SharedOrderFunctions.checkMotivationLetters();
                }
            }
            SharedOrderFunctions.GetInvoiceInformation();
        }
    },
    checkMotivationLetters: function(){
        let nProcedureUIDs = [];
        $('tr.selectedProcedureItem').each(function (i, y) {
            nProcedureUIDs.push($(y).find('td.procedure input.id').val());
        });
        const implementation = $('input#DateOfImplementation').val();
        const reqRes = SharedOrderFunctions.CheckMotivationLettersCall(modelPatientID, implementation, null, nProcedureUIDs).done(function (e) {
            if (reqRes.responseJSON.AllOk && (reqRes.responseJSON.Items.length > 0 || reqRes.responseJSON.ProcedureEFs.length > 0)) {
                // Order EFs
                $.each(reqRes.responseJSON.Items, function (i, y) {
                    let text = y.ExportFormat_Text;
                    let amount = y.Amount;
                    let val = y.ExportFormat_UID;
                    let triggerStatus = y.TriggerStatus;
                    let orderTriggerStatusID = y.OrderTriggerStatusUID;
                    let reportTriggerStatusID = y.ReportTriggerStatusUID;

                    $('input.orderEFID[value=' + val + ']').each(function (i, y) {
                        $(y).parent().parent().remove();
                    });

                    var toAppend = '<tr class="orderExportFormatRow"><td>' + text;
                    toAppend += '<input class="orderEFName" type="hidden" value="' + text + '" name="ListOrderExportFormat[0].Name" />';
                    toAppend += '<input class="orderEFID" type="hidden" value="' + val + '" name="ListOrderExportFormat[0].ID" />';
                    toAppend += '<input class="orderEFPartial" type="hidden" value="false" name=ListOrderExportFormat[0].UseInPartial /></td>';
                    toAppend += '<td><input class="orderEFAmount spinner" value="' + amount + '" name="ListOrderExportFormat[0].Amount" /></td>';
                    toAppend += '<td>' + triggerStatus + '<input type="hidden" class="triggerStatus" name="ListOrderExportFormat[0].TriggerStatus" value="' + triggerStatus + '" />';
                    toAppend += '<input type="hidden" class="orderEFOrderTriggerStatus" name="ListOrderExportFormat[0].OrderTriggerStatus_UID" value="' + orderTriggerStatusID + '" />';
                    toAppend += '<input type="hidden" class="orderEFReportTriggerStatus" name="ListOrderExportFormat[0].ReportTriggerStatus_UID" value="' + reportTriggerStatusID + '" />';
                    toAppend += '<td class="delete">' + htmlDecode(resourceDelete) + '</td></tr>';
                    $('#tblOrderExportFormats').append(toAppend);
                    $('.spinner').spinner({
                        step: 1,
                        min: 1
                    });
                    $('.spinner').ForceNumericOnly();
                    SharedOrderFunctions.sortOrderExportFormats();
                });

                // Procedure EFs
                const container = $('table#tblProcedureExportFormat tbody');
                const existingRecords = $(container).find(".procedureExportFormatRow");
                const existingMotivationRecords = $(existingRecords)
                    .filter(function (index, element) {
                        return $(element)
                            .find("input.procedureEFProcedureLinkID")
                            .val() != '0';
                    });

                $(existingMotivationRecords).remove();
                $.each(reqRes.responseJSON.ProcedureEFs, function(i, x) {
                    let toAdd = '<tr class="procedureExportFormatRow" id="' + x.ProcedureLinkID + '">';
                    toAdd += SharedOrderFunctions.CreateProcedureEFHTML(i, x, resourcePartialReport);
                    toAdd += '<td class="delete">resourceDelete</td>';
                    toAdd += '</tr>';
                    $('table#tblProcedureExportFormat tbody').append(toAdd);
                });
            }
        });
    },
    sortOrderExportFormats: function()
    {
        const formats = $('table#tblOrderExportFormats').find('tr.orderExportFormatRow');
        $.each(formats, function (index, obj)
        {
            $(formats[index]).find('input.orderEFID').attr('name', 'ListOrderExportFormat[' + index + '].ID');
            $(formats[index]).find('input.orderEFName').attr('name', 'ListOrderExportFormat[' + index + '].Name');
            $(formats[index]).find('input.orderEFAmount').attr('name', 'ListOrderExportFormat[' + index + '].Amount');
            $(formats[index]).find('input.orderEFPartial').attr('name', 'ListOrderExportFormat[' + index + '].UseInPartial');
            $(formats[index]).find('input.orderEFUID').attr('name', 'ListOrderExportFormat[' + index + '].OrderHasExport_UID');
            $(formats[index]).find('input.orderEFDone').attr('name', 'ListOrderExportFormat[' + index + '].Done');
            $(formats[index]).find('input.triggerStatus').attr('name', 'ListOrderExportFormat[' + index + '].TriggerStatus');
            $(formats[index]).find('input.orderEFOrderTriggerStatus').attr('name', 'ListOrderExportFormat[' + index + '].OrderTriggerStatus_UID');
            $(formats[index]).find('input.orderEFReportTriggerStatus').attr('name', 'ListOrderExportFormat[' + index + '].ReportTriggerStatus_UID');
        });
    },
    setCertificateNumber: function(certificateNumber)
    {
        if (modelInvoiceCertificate)
        {
            $('.invoiceCertificateNumber').show();
            $('input#InvoiceCertificateNumber').val(certificateNumber);
            $('input#InvoiceCertificateNumber').attr('value', certificateNumber);
        }
        else
        {
            $('.invoiceCertificateNumber').hide();
            $('input#InvoiceCertificateNumber').val("");
            $('input#InvoiceCertificateNumber').attr('value', '');
        }
    },
    setPaymentMethod: function(paymentMethod)
    {
        if(!paymentMethod) return;
        $('input[type=radio][name=InvoicePaymentMethod]').removeAttr('checked');
        $('input[type=radio][name=InvoicePaymentMethod]').removeProp('checked');

        $('input[name=InvoicePaymentMethod][value=' + paymentMethod + ']:radio').prop('checked', true);
        $('input[name=InvoicePaymentMethod][value=' + paymentMethod + ']:radio').attr('checked', true);
    },
    handleReadyForInvoicingCheckbox: function(checkbox) {
        var self = $(checkbox);
        var isChecked = self.prop('checked');

        if (isChecked) {
            self.attr('checked', 'checked');
        } else {
            self.removeAttr('checked');
        }

        $.ajax({
            type: "POST",
            url: "/legacy/Orders/SetReadyForInvoicing",
            async: true,
            data: {
                orderID: self.parent().parent().parent().find('span.id').text(),
                ready: isChecked
            },
            datatype: 'json',
            success: function (data) {
                if (data.AllOk) {
                    if (isChecked) {
                        self.parent().prop('title', '@Global.ControlledBy ' + data.Username + ' (' + data.Timestamp + ')');
                        self.parent().find('input.readyForInvoicingDatetime').val(data.Timestamp);
                        self.parent().find('input.readyForInvoicingByUID').val(data.UserUID);
                        self.parent().find('input.readyForInvoicingByUsername').val(data.Username);
                    } else {
                        self.parent().removeAttr('title');
                        self.parent().find('input.readyForInvoicingDatetime').val('');
                        self.parent().find('input.readyForInvoicingByUID').val('');
                        self.parent().find('input.readyForInvoicingByUsername').val('');
                    }
                }
            }
        });
    }
};
